import { InternalContactsListVendor } from '../../../../components/Contact/InternalContact';

export function TBMContactInternalContacts() {
  return <InternalContactsListVendor />;
}
